import { activityConstants } from '../constants';

const initialState = {
    loading: false,
    activities: [],
    error: null,
    creatingActivity: false,
    createError: null,
    updatingActivity: false,
    updateError: null,
};

const activityReducer = (state = initialState, action) => {
    switch (action.type) {
        case activityConstants.FETCH_ACTIVITIES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case activityConstants.FETCH_ACTIVITIES_SUCCESS:
            return {
                ...state,
                loading: false,
                activities: action.activities,
                error: null
            };
        case activityConstants.FETCH_ACTIVITIES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case activityConstants.CREATE_ACTIVITY_REQUEST:
            return {
                ...state,
                creatingActivity: true,
                createError: null,
            };
        case activityConstants.CREATE_ACTIVITY_SUCCESS:
            return {
                ...state,
                creatingActivity: false,
                activities: action.activities,
            };
        case activityConstants.CREATE_ACTIVITY_FAILURE:
            return {
                ...state,
                creatingActivity: false,
                createError: action.payload,
            };

        case activityConstants.UPDATE_ACTIVITY_REQUEST:
            return {
                ...state,
                updatingActivity: true,
                updateError: null,
            };
        case activityConstants.UPDATE_ACTIVITY_SUCCESS:
            return {
                ...state,
                activities: action.activities,
                updatingActivity: false,
                updateError: null,
            };
        case activityConstants.UPDATE_ACTIVITY_FAILURE:
            return {
                ...state,
                updatingActivity: false,
                updateError: action.payload,
            };
        case activityConstants.DELETE_ACTIVITY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case activityConstants.DELETE_ACTIVITY_SUCCESS:
            return {
                ...state,
                loading: false,
                activities: state.activities.filter(a => a.ActivityID !== action.payload),
            };
        case activityConstants.DELETE_ACTIVITY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default activityReducer;
